import FeatureCard from '../components/FeatureCard';
import ModernPropertyDropdown from '../modern/PropertyDropdown';
import ModernPropertyPicker from '../modern/PropertyPicker';
import PropertyPicker from '../components/PropertyPicker';
import PropertyDropdown from '../components/PropertyDropdown';

const SensorSettingsCluster = ({
    silentDimmingLevel,
    occupyDimmingLevel,
    triggerVoltage,
    detectionLogic,
    handleChange,
    className,
    variant,
    style,
}) => {
    const Dropdown = variant === 'modern' ? ModernPropertyDropdown : PropertyDropdown;
    const Picker = variant === 'modern' ? ModernPropertyPicker : PropertyPicker;
    return (
        <FeatureCard title="Sensor Settings" className={className} style={style} variant={variant} bodyLayout="fields">
            {/* The two global dimming levels are optional: schedule-driven opmodes (astdimsens) set the
            occupied/unoccupied levels per time slot instead, so they omit these props entirely. */}
            {silentDimmingLevel && (
                <Picker
                    property={silentDimmingLevel}
                    inputPadding={'padding-none'}
                    title={silentDimmingLevel.info.displayName}
                    measureUnit={silentDimmingLevel.info.unit}
                    min={silentDimmingLevel.valueMeta.min}
                    max={silentDimmingLevel.valueMeta.max}
                    step={1}
                    titleSize={9}
                    inputSize={2}
                    unitSize={1}
                    handleChange={handleChange} />
            )}
            {occupyDimmingLevel && (
                <Picker
                    property={occupyDimmingLevel}
                    inputPadding={'padding-none'}
                    title={occupyDimmingLevel.info.displayName}
                    measureUnit={occupyDimmingLevel.info.unit}
                    min={occupyDimmingLevel.valueMeta.min}
                    max={occupyDimmingLevel.valueMeta.max}
                    step={1}
                    titleSize={9}
                    inputSize={2}
                    unitSize={1}
                    handleChange={handleChange} />
            )}
            <Picker
                property={triggerVoltage}
                inputPadding={'padding-none'}
                title={triggerVoltage.info.displayName}
                measureUnit={triggerVoltage.info.unit}
                min={triggerVoltage.valueMeta.min}
                max={triggerVoltage.valueMeta.max}
                titleSize={9}
                inputSize={2}
                unitSize={1}
                step={0.1}
                handleChange={handleChange} />
            <Dropdown
                translate={false}
                property={detectionLogic}
                properties={detectionLogic.valueMeta.availableValues}
                title={detectionLogic.info.displayName}
                measureUnit={''}
                step={1}
                handleChange={handleChange}
                dropdownStyle={{ padding: '0px', display: 'flex', justifyContent: 'flex-end' }}
                titleSize={6}
                dropdownSize={6} />
        </FeatureCard>
    );
};

export default SensorSettingsCluster;
